import Risk from './fundManagement/fundManagement'
const SUB_SYSTEM = 'product'
// 资金方管理
export const fundManagementApi = new Risk(SUB_SYSTEM, 'fundsprovider')
